// Auto generated file, do not manually modify!
// com.hotpads.rins.api.web.handler.ProofOfInsuranceWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  EmailRequestResultDto,
  GetTenantsListWebApiRequestDto,
  GetTenantsListWebApiResponseDto,
  SendProofRequestWebApiRequestDto,
} from '../..';

export const ProofOfInsuranceWebApiHandler_getTenantsList_Path = '/api/web/v1/proofOfInsurance/getTenantsList';

/**
 * Get a list of tenants with the request status
 */
export const ProofOfInsuranceWebApiHandler_getTenantsList = (
  postData: GetTenantsListWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, GetTenantsListWebApiRequestDto, GetTenantsListWebApiResponseDto>(
    {
      endpoint: ProofOfInsuranceWebApiHandler_getTenantsList_Path,
      method: 'POST',
      contextPath: '/rins',
      postData: postData,
    },
    client,
  );
};

export const ProofOfInsuranceWebApiHandler_sendProofRequestEmail_Path =
  '/api/web/v1/proofOfInsurance/sendProofRequestEmail';

/**
 * Send an email reminder to Rachels to upload their proof of insurance
 */
export const ProofOfInsuranceWebApiHandler_sendProofRequestEmail = (
  postData: SendProofRequestWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, SendProofRequestWebApiRequestDto, EmailRequestResultDto>(
    {
      endpoint: ProofOfInsuranceWebApiHandler_sendProofRequestEmail_Path,
      method: 'POST',
      contextPath: '/rins',
      postData: postData,
    },
    client,
  );
};
